import { type PaymentMethod } from '@/types/checkout';
import type { StripeExpressCheckoutElementConfirmEvent } from '@stripe/stripe-js';
import { type PaymentMethod as StripePaymentMethod } from '@stripe/stripe-js';

export const buildStripeLinkPaymentParams = (
  card: StripePaymentMethod.Card,
  paymentMethodSettings: PaymentMethod,
  event: StripeExpressCheckoutElementConfirmEvent,
  email: string,
  paymentTokenId: string
) => {
  const { billingDetails } = event;

  return {
    paymentProvider: 'stripe',
    receipt_email: event.billingDetails?.email || email || '',
    paymentMethodDisplayName: 'Link',
    paymentMethodId: paymentMethodSettings.id,
    params: {
      paymentMethodId: paymentTokenId,
      cardDetails: {
        bin: '',
        nameOnCard: billingDetails?.name || '',
        lastFourDigits: card?.last4 || '',
        expirationMonth: card?.exp_month || '',
        expirationYear: card?.exp_year || '',
        cardBrand: card?.brand || '',
        fingerprint: '',
        countryOfIssuance: event.billingDetails?.address.country || '',
      },
      paymentMethodDetails: {
        id: paymentTokenId,
        object: 'payment_method',
        allow_redisplay: 'unspecified',
        billing_details: {
          address: {
            city: billingDetails?.address?.city || null,
            country: billingDetails?.address?.country || null,
            line1: billingDetails?.address?.line1 || null,
            line2: billingDetails?.address?.line2 || null,
            postal_code: billingDetails?.address?.postal_code || null,
            state: billingDetails?.address?.state || null,
          },
          email: billingDetails?.email || email || '',
          name: billingDetails?.name || null,
          phone: billingDetails?.phone || null,
          tax_id: null,
        },
        card: {
          brand: card?.brand || '',
          checks: {
            address_line1_check: null,
            address_postal_code_check: null,
            cvc_check: null,
          },
          country: event.billingDetails?.address.country || '',
          display_brand: card?.brand || '',
          exp_month: card?.exp_month || 0,
          exp_year: card?.exp_year || 0,
          funding: card?.funding || '',
          generated_from: null,
          last4: card?.last4 || '',
          networks: {
            available: [card?.brand || ''],
            preferred: null,
          },
          regulated_status: 'unregulated',
          three_d_secure_usage: {
            supported: card.three_d_secure_usage?.supported || true,
          },
          wallet: card?.wallet
            ? {
                dynamic_last4: card.wallet.dynamic_last4 || null,
                link: {},
                type: 'link',
              }
            : null,
        },
        created: Math.floor(Date.now() / 1000),
        customer: null,
        livemode: false,
        type: 'card',
      },
      shouldSaveCard: false,
      fraudDetection: {
        forterTokenCookie: '',
      },
    },
  };
};
